import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, OnInit, signal } from '@angular/core';
import { LocaleDatePipe } from '@app/pipes/locale-date.pipe';
import { Store } from '@ngrx/store';
import { TranslatePipe } from '@ngx-translate/core';
import { AppState } from '@reducers/interfaces';
import { getWeatherForWidget } from '@reducers/orm/weather/weather.selector';
import { WeatherService } from '@reducers/orm/weather/weather.service';
import { mgcIconSunCloudyCuteRe } from '@sb/mgc-icons/mgcIcon-sun_cloudy_cute_re.icon';
import { DashboardWidgetComponent } from '@sb/ui/dashboard-widget/dashboard.widget.component';
import { IconRegistry } from '@sb/ui/icon';
import { WeatherIconComponent } from '@sb/weather';
import { dayList, toISODateString } from '@shiftbase-com/ts-shared/utilities';
import { addDays } from 'date-fns';
import { finalize } from 'rxjs';

const FORECAST_DAYS = 3;
const MIN_DATE = new Date();
const MAX_DATE = addDays(new Date(), FORECAST_DAYS);

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'my-weather-forecast-widget',
  templateUrl: './my-weather-forecast-widget.component.html',
  imports: [DashboardWidgetComponent, TranslatePipe, LocaleDatePipe, WeatherIconComponent, NgClass],
})
export class MyWeatherForecastWidgetComponent implements OnInit {
  private store = inject<Store<AppState>>(Store);
  private weatherService = inject(WeatherService);
  private iconRegistry = inject(IconRegistry);

  isLoading = signal(false);

  dates: string[];

  departmentForecasts = this.store.selectSignal(getWeatherForWidget(MIN_DATE, MAX_DATE));

  constructor() {
    this.iconRegistry.registerIcons([mgcIconSunCloudyCuteRe]);
  }

  ngOnInit() {
    this.dates = dayList(MIN_DATE, MAX_DATE);
    this.loadData();
  }

  private loadData() {
    const period = {
      minDate: toISODateString(MIN_DATE),
      maxDate: toISODateString(MAX_DATE),
    };

    this.isLoading.set(true);
    void this.weatherService
      .load(period, true)
      .pipe(finalize(() => this.isLoading.set(false)))
      .subscribe();
  }
}
